var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_115_735)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#9BCD9B"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_115_735)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0025 12.1953C13.8647 12.1953 12.1403 13.8927 12.1403 15.9971C12.1403 18.1015 13.8647 19.799 16.0025 19.799C18.1403 19.799 19.8647 18.1015 19.8647 15.9971C19.8647 13.8927 18.1403 12.1953 16.0025 12.1953ZM16.0025 18.4688C14.621 18.4688 13.4916 17.3604 13.4916 15.9971C13.4916 14.6339 14.6176 13.5254 16.0025 13.5254C17.3874 13.5254 18.5134 14.6339 18.5134 15.9971C18.5134 17.3604 17.384 18.4688 16.0025 18.4688ZM20.9235 12.0398C20.9235 12.5328 20.5202 12.9265 20.0227 12.9265C19.5218 12.9265 19.1218 12.5295 19.1218 12.0398C19.1218 11.5501 19.5252 11.153 20.0227 11.153C20.5202 11.153 20.9235 11.5501 20.9235 12.0398ZM23.4815 12.9398C23.4244 11.7519 23.1487 10.6997 22.2647 9.83279C21.384 8.96588 20.3151 8.69456 19.1084 8.635C17.8647 8.56551 14.137 8.56551 12.8933 8.635C11.6899 8.69125 10.621 8.96257 9.73697 9.82948C8.85294 10.6964 8.58067 11.7486 8.52017 12.9365C8.44958 14.1607 8.44958 17.8302 8.52017 19.0545C8.57731 20.2423 8.85294 21.2946 9.73697 22.1615C10.621 23.0284 11.6865 23.2997 12.8933 23.3593C14.137 23.4287 17.8647 23.4287 19.1084 23.3593C20.3151 23.303 21.384 23.0317 22.2647 22.1615C23.1454 21.2946 23.421 20.2423 23.4815 19.0545C23.5521 17.8302 23.5521 14.164 23.4815 12.9398ZM21.8748 20.3681C21.6126 21.0166 21.105 21.5162 20.4428 21.7776C19.4513 22.1648 17.0983 22.0754 16.0025 22.0754C14.9067 22.0754 12.5504 22.1615 11.5622 21.7776C10.9034 21.5196 10.3958 21.0199 10.1302 20.3681C9.73697 19.392 9.82773 17.0758 9.82773 15.9971C9.82773 14.9185 9.74033 12.599 10.1302 11.6262C10.3924 10.9776 10.9 10.478 11.5622 10.2166C12.5538 9.82948 14.9067 9.91882 16.0025 9.91882C17.0983 9.91882 19.4546 9.83279 20.4428 10.2166C21.1017 10.4747 21.6092 10.9743 21.8748 11.6262C22.2681 12.6023 22.1773 14.9185 22.1773 15.9971C22.1773 17.0758 22.2681 19.3953 21.8748 20.3681Z",
    fill: "#F3F5FB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_115_735"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_115_735"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.0588,
    height: 16.9412,
    fill: "white",
    transform: "translate(8.47034 7.52942)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramHover);
export default __webpack_public_path__ + "static/media/instagramHover.f101d3d58d95a1747c1497c20ff2f103.svg";
export { ForwardRef as ReactComponent };